import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import AffiliateSidebar from './AffiliateSidebar';
import { useTheme } from './ThemeContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';

function AffiliatePortalLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { theme } = useTheme();

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div 
      className="flex h-screen"
      style={{ backgroundColor: theme.backgroundPrimary || '#f3f4f6' }}
    >
      {/* Sidebar */}
      <AffiliateSidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      
      {/* Main Content Area */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Mobile Header */}
        <div 
          className="lg:hidden shadow-sm p-4 flex items-center justify-between"
          style={{ backgroundColor: theme.headerBG || '#ffffff' }}
        >
          <button
            onClick={toggleSidebar}
            className="p-2 rounded-md transition-colors duration-200"
            style={{ color: theme.textPrimary || '#4b5563' }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = theme.hoverBG || '#f3f4f6';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'transparent';
            }}
          >
            <FontAwesomeIcon icon={faBars} />
          </button>
          <h1 
            className="text-lg font-semibold"
            style={{ color: theme.textPrimary || '#111827' }}
          >
            Partner Portal
          </h1>
          <div className="w-10"></div> {/* Spacer for centering */}
        </div>
        
        {/* Page Content */}
        <main className="flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default AffiliatePortalLayout;